import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Don't redirect on /auth/me or login endpoints
      const url = err.config?.url || "";
      if (!url.includes("/auth/")) {
        window.location.href = "/giris";
      }
    }
    return Promise.reject(err);
  }
);

export function formatErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatTL(n) {
  if (n === null || n === undefined || isNaN(n)) return "0,00 ₺";
  return new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n) + " ₺";
}

export function normalizePhone(raw) {
  const n = (raw || "").replace(/\D/g, "");
  if (!n) return "";
  if (n.startsWith("90") && n.length >= 12) return n;
  if (n.startsWith("0")) return "90" + n.slice(1);
  if (n.length === 10) return "90" + n;
  return n;
}

export function waLink(phone, message = "") {
  const n = normalizePhone(phone);
  if (!n) return "#";
  return `https://wa.me/${n}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
}

export function formatDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function formatTime(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export const ROLE_LABELS = {
  klinik_sahibi: "Klinik Sahibi",
  dis_hekimi: "Diş Hekimi",
  sekreter: "Sekreter",
  asistan: "Asistan",
  super_admin: "Süper Admin",
};

export const APPT_STATUS_LABELS = {
  scheduled: "Planlandı",
  confirmed: "Onaylandı",
  in_progress: "Devam Ediyor",
  completed: "Tamamlandı",
  cancelled: "İptal",
  no_show: "Gelmedi",
  pending_confirmation: "Onay Bekliyor",
};

export const APPT_STATUS_COLORS = {
  scheduled: "bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-500/10 dark:text-sky-300 dark:border-sky-500/20",
  confirmed: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:border-emerald-500/20",
  in_progress: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/20",
  completed: "bg-teal-100 text-teal-700 border-teal-200 dark:bg-teal-500/10 dark:text-teal-300 dark:border-teal-500/20",
  cancelled: "bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-500/10 dark:text-rose-300 dark:border-rose-500/20",
  no_show: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-500/10 dark:text-slate-300 dark:border-slate-500/20",
  pending_confirmation: "bg-orange-100 text-orange-700 border-orange-200 dark:bg-orange-500/10 dark:text-orange-300 dark:border-orange-500/20",
};
